import { useContext, useEffect } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { ClaimsComponent, LayoutContext } from '@/_shared/components';
import { Roles } from '@/_shared/constants';
import { DashboardAdmin } from './DashboardAdmin';
import { DashboardLearning } from './DashboardLearning';

export const DashboardScreen = () => {
  const t = useTranslations('dashboard.welcome');

  const { setLayout } = useContext(LayoutContext);

  useEffect(() => {
    setLayout({ title: 'dashboard' });
  }, [setLayout, t]);

  return (
    <>
      <ClaimsComponent roles={[Roles.Admin, Roles.HR_Delegate]}>
        <DashboardAdmin />
      </ClaimsComponent>
      <ClaimsComponent roles={[Roles.Manager, Roles.Employee]}>
        <DashboardLearning />
      </ClaimsComponent>
    </>
  );
};
